import React from "react";
import useTheme from '../hooks/useTheme';


const Loader = () => {
    const { getThemeClass } = useTheme();
    return (
        <div className="bundleBackgroundLoader">
            <div className={getThemeClass('loader')}></div>
        </div>
    );
}

export default Loader;